import { isRSC, useIsomorphicLayoutEffect } from "@tamagui/constants";
import { useContext, useState } from "react";
import { getConfig } from "../config.js";
import { ThemeManagerContext } from "../helpers/ThemeManagerContext.js";
function useThemeName(opts) {
  if (isRSC) {
    const config = getConfig();
    return config.themes[Object.keys(config.themes)[0]];
  }
  const manager = useContext(ThemeManagerContext);
  const [name, setName] = useState((manager == null ? void 0 : manager.state.name) || "");
  useIsomorphicLayoutEffect(() => {
    if (!manager)
      return;
    setName(manager.state.name);
    return manager.onChangeTheme((next, manager2) => {
      const name2 = (opts == null ? void 0 : opts.parent) ? manager2.state.parentName || next : next;
      if (!name2)
        return;
      setName(name2);
    });
  }, [manager == null ? void 0 : manager.state.name]);
  return name;
}
export {
  useThemeName
};
//# sourceMappingURL=useThemeName.js.map
